"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isArcgisAccessToken: () => isArcgisAccessToken,
  isArcgisAuthCode: () => isArcgisAuthCode,
  isArcgisAuthorization: () => isArcgisAuthorization,
  isArcgisAuthorizationStatus: () => isArcgisAuthorizationStatus,
  isArcgisExportComplete: () => isArcgisExportComplete,
  isArcgisExportEvent: () => isArcgisExportEvent,
  isArcgisExportFailed: () => isArcgisExportFailed,
  isArcgisExportResult: () => isArcgisExportResult,
  isArcgisExportSkipped: () => isArcgisExportSkipped,
  isArcgisExportStatus: () => isArcgisExportStatus,
  isArcgisIntegration: () => isArcgisIntegration,
  isArcgisIntegrationCreate: () => isArcgisIntegrationCreate,
  isArcgisIntegrationId: () => isArcgisIntegrationId,
  isArcgisIntegrationStatus: () => isArcgisIntegrationStatus,
  isArcgisIntegrationUpdate: () => isArcgisIntegrationUpdate,
  isArcgisLayerUrl: () => isArcgisLayerUrl,
  isArcgisRefreshToken: () => isArcgisRefreshToken
});
module.exports = __toCommonJS(types_generated_exports);
var import_types_generated = require("../core/types.generated.js");
var import_util = require("@cartographerio/util");
const isArcgisIntegrationId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ArcgisIntegrationId")(v);
};
const isArcgisLayerUrl = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ArcgisLayerUrl")(v);
};
const isArcgisAccessToken = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ArcgisAccessToken")(v);
};
const isArcgisRefreshToken = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ArcgisRefreshToken")(v);
};
const isArcgisAuthCode = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ArcgisAuthCode")(v);
};
const isArcgisIntegration = (v) => {
  return typeof v === "object" && v != null && "name" in v && typeof v.name === "string" && "projectId" in v && (0, import_types_generated.isProjectId)(v.projectId) && "layerId" in v && (0, import_types_generated.isMapLayerId)(v.layerId) && "arcgisLayerUrl" in v && isArcgisLayerUrl(v.arcgisLayerUrl) && "exportSimplifiedGeometry" in v && typeof v.exportSimplifiedGeometry === "boolean" && "enableScheduledExports" in v && typeof v.enableScheduledExports === "boolean" && (!("notificationEmail" in v) || (0, import_types_generated.isNamedEmail)(v.notificationEmail) || v.notificationEmail === null) && "created" in v && (0, import_types_generated.isTimestamp)(v.created) && "id" in v && isArcgisIntegrationId(v.id);
};
const isArcgisIntegrationCreate = (v) => {
  return typeof v === "object" && v != null && "name" in v && typeof v.name === "string" && "projectId" in v && (0, import_types_generated.isProjectId)(v.projectId) && "layerId" in v && (0, import_types_generated.isMapLayerId)(v.layerId) && "arcgisLayerUrl" in v && isArcgisLayerUrl(v.arcgisLayerUrl) && (!("exportSimplifiedGeometry" in v) || typeof v.exportSimplifiedGeometry === "boolean" || v.exportSimplifiedGeometry === null) && "enableScheduledExports" in v && typeof v.enableScheduledExports === "boolean" && (!("notificationEmail" in v) || (0, import_types_generated.isNamedEmail)(v.notificationEmail) || v.notificationEmail === null);
};
const isArcgisIntegrationUpdate = (v) => {
  return typeof v === "object" && v != null && "name" in v && typeof v.name === "string" && "enableScheduledExports" in v && typeof v.enableScheduledExports === "boolean" && (!("notificationEmail" in v) || (0, import_types_generated.isNamedEmail)(v.notificationEmail) || v.notificationEmail === null);
};
const isArcgisAuthorization = (v) => {
  return typeof v === "object" && v != null && "integrationId" in v && isArcgisIntegrationId(v.integrationId) && (!("arcgisUsername" in v) || typeof v.arcgisUsername === "string" || v.arcgisUsername === null) && "accessToken" in v && isArcgisAccessToken(v.accessToken) && (!("refreshToken" in v) || isArcgisRefreshToken(v.refreshToken) || v.refreshToken === null) && (!("accessTokenExpires" in v) || (0, import_types_generated.isTimestamp)(v.accessTokenExpires) || v.accessTokenExpires === null) && (!("refreshTokenExpires" in v) || (0, import_types_generated.isTimestamp)(v.refreshTokenExpires) || v.refreshTokenExpires === null) && "created" in v && (0, import_types_generated.isTimestamp)(v.created);
};
const isArcgisExportComplete = (v) => {
  return typeof v === "object" && v != null && "message" in v && typeof v.message === "string";
};
const isArcgisExportFailed = (v) => {
  return typeof v === "object" && v != null && "message" in v && typeof v.message === "string";
};
const isArcgisExportSkipped = (v) => {
  return typeof v === "object" && v != null && "message" in v && typeof v.message === "string";
};
const isArcgisExportResult = (v) => {
  return typeof v === "object" && v != null && "type" in v && (v.type === "Complete" && isArcgisExportComplete(v) || v.type === "Failed" && isArcgisExportFailed(v) || v.type === "Skipped" && isArcgisExportSkipped(v));
};
const isArcgisExportEvent = (v) => {
  return typeof v === "object" && v != null && "timestamp" in v && (0, import_types_generated.isTimestamp)(v.timestamp) && "integrationId" in v && isArcgisIntegrationId(v.integrationId) && "layerId" in v && (0, import_types_generated.isMapLayerId)(v.layerId) && "arcgisLayerUrl" in v && isArcgisLayerUrl(v.arcgisLayerUrl) && "result" in v && isArcgisExportResult(v.result);
};
const isArcgisAuthorizationStatus = (v) => {
  return typeof v === "object" && v != null && "lastAuthorized" in v && (0, import_types_generated.isTimestamp)(v.lastAuthorized) && (!("lastAuthorizedAs" in v) || typeof v.lastAuthorizedAs === "string" || v.lastAuthorizedAs === null) && (!("lastAuthorizationExpires" in v) || (0, import_types_generated.isTimestamp)(v.lastAuthorizationExpires) || v.lastAuthorizationExpires === null);
};
const isArcgisExportStatus = (v) => {
  return typeof v === "object" && v != null && "lastExported" in v && (0, import_types_generated.isTimestamp)(v.lastExported) && "lastExportResult" in v && isArcgisExportResult(v.lastExportResult);
};
const isArcgisIntegrationStatus = (v) => {
  return typeof v === "object" && v != null && "integration" in v && isArcgisIntegration(v.integration) && (!("authorization" in v) || isArcgisAuthorizationStatus(v.authorization) || v.authorization === null) && (!("export" in v) || isArcgisExportStatus(v.export) || v.export === null);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isArcgisAccessToken,
  isArcgisAuthCode,
  isArcgisAuthorization,
  isArcgisAuthorizationStatus,
  isArcgisExportComplete,
  isArcgisExportEvent,
  isArcgisExportFailed,
  isArcgisExportResult,
  isArcgisExportSkipped,
  isArcgisExportStatus,
  isArcgisIntegration,
  isArcgisIntegrationCreate,
  isArcgisIntegrationId,
  isArcgisIntegrationStatus,
  isArcgisIntegrationUpdate,
  isArcgisLayerUrl,
  isArcgisRefreshToken
});
//# sourceMappingURL=types.generated.js.map
